export function passwordStrengthChecks(pw) {
  return {
    length: pw.length >= 8,
    upper: /[A-Z]/.test(pw),
    lower: /[a-z]/.test(pw),
    number: /\d/.test(pw),
    special: /[\W_]/.test(pw),
  };
}

export function passwordMeetsStrength(pw) {
  const c = passwordStrengthChecks(pw);
  return c.length && c.upper && c.lower && c.number && c.special;
}
